export default __webpack_public_path__ + "static/media/void-cheque-2x.b6b35722.png";